import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/legal-pages.css';

const TermsAndConditionsPage: React.FC = () => {
  return (
    <div className="legal-page">
      <div className="legal-page-container">
        <h1 className="legal-page-title">Terms and Conditions</h1>
        
        <p className="legal-page-date"><strong>Effective Date:</strong> 10/01/2025</p>
        
        <p className="legal-page-intro">
          By opting in to receive SMS messages from Muse Legal Group, P.C. ("we," "us," "our"), you agree to these Terms and Conditions (Terms).
        </p>

        <section className="legal-section">
          <h2>SMS Messaging Service</h2>
          <p>
            Muse Legal Group, PC may send you conversational messages via SMS. Message frequency may vary. On average, you may receive 1-10 messages per month. Message and data rates may apply.
          </p>
          <p>
            By providing my phone number, I consent to receive SMS text messages from Muse Legal Group, P.C. for appointment reminders, marketing messages, and general two-way communication about your case and legal services.
          </p>
        </section>

        <section className="legal-section">
          <h2>Unsubscribe and Help</h2>
          <p>
            To unsubscribe from SMS messages, reply STOP at any time.
          </p>
          <p>
            For help or more information, reply HELP.
          </p>
          <p>
            For details on how your information is handled, please review our <Link to="/privacy-policy" className="legal-link">Privacy Policy</Link>.
          </p>
        </section>

        <section className="legal-section">
          <h2>Message Frequency</h2>
          <p>
            You will get more than one message from us unless you opt-out, and while messaging frequency varies, you will likely receive 1-10 text messages per month. Muse Legal Group, P.C. reserves the right to alter the frequency of messages at any time to increase or decrease the total number of messages. Muse Legal Group, P.C. and carriers are not liable for delays or undelivered messages.
          </p>
        </section>

        <section className="legal-section">
          <h2>Message and Data Rates</h2>
          <p>
            Message and data rates may apply based on your mobile carrier's terms.
          </p>
        </section>


        <section className="legal-section">
          <h2>Customer Support</h2>
          <p>
            You may contact us directly at <a href="tel:8182458888" className="legal-link">(818) 245-8888</a> or <a href="mailto:admin@muselegalgroup.com" className="legal-link">admin@muselegalgroup.com</a>.
          </p>
        </section>

        <section className="legal-section">
          <h2>Liability</h2>
          <p>
            We are not responsible for any charges, errors, or delays in SMS delivery or undelivered messages caused by your carrier or third-party service providers.
          </p>
        </section>

        <div className="legal-page-footer">
          <Link to="/" className="legal-back-link">← Back to Home</Link>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditionsPage;

